import React, { useCallback, useState } from 'react';

import { Popover as MuiPopover } from '@material-ui/core';

const Popover = ({
    children,
    disabled,
    popoverId,
    popoverContent,
    ...otherProps
}) => {
    const [anchorElement, setAnchorElement] = useState(null);
    const open = Boolean(anchorElement);
    const id = open ? popoverId : undefined;

    const closePopover = useCallback(() => {
        setAnchorElement(null);
    }, []);

    const handleClick = useCallback(event => {
        setAnchorElement(event.currentTarget);
    }, []);

    return (
        <div>
            <a
                role="button"
                tabIndex="-1"
                aria-describedby={id}
                onClick={!disabled ? handleClick : null}
            >
                {children}
            </a>
            <MuiPopover
                open={open}
                id={popoverId}
                onClose={closePopover}
                anchorEl={anchorElement}
                {...otherProps}
            >
                <div
                    onMouseLeave={closePopover}
                >
                    {popoverContent}
                </div>
            </MuiPopover>
        </div>
    );
};

Popover.defaultProps = {
    popoverId: 'popover',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
};

export default Popover;
